import { useEffect, useState } from 'react';

/** When each successive wording takes over, in ms since the reply was asked for. */
export const THINKING_PHASE_DELAYS = [4000, 10000] as const;

/**
 * Which of the progressive "thinking" wordings to show. A long wait with one
 * frozen label reads as a hang, so the copy escalates while the reply streams.
 * Resets to 0 on every new request, including one started before the last
 * finished settling.
 */
export function useThinkingPhase(isLoading: boolean): number {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    setPhase(0);
    if (!isLoading) return;

    const timers = THINKING_PHASE_DELAYS.map((delay, index) =>
      setTimeout(() => setPhase(index + 1), delay),
    );
    return () => timers.forEach(clearTimeout);
  }, [isLoading]);

  return phase;
}
